import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle, clearPageTitle } from '../store/navigationSlice';

export const usePageTitle = (title) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle(title));
        
        return () => {
            dispatch(clearPageTitle());
        };
    }, [dispatch, title]);
};
